import { z } from "zod";

export const siteDsoConsentsDtoSchema = z.object({
  dailyIndexTransmission: z.boolean(),
  dailyPowerMaxTransmission: z.boolean(),
  loadCurveTransmission: z.boolean(),
  technicalAndContractualData: z.boolean(),
});

export type TSiteDsoConsentsDto = z.infer<typeof siteDsoConsentsDtoSchema>;
